import React from "react";
import { useHistory } from "react-router-dom";

import { Button, Buttons, SecondaryButton, Spacer } from "../../base";

const ModalButtons = ({
  loading,
  onClickPrimary,
  onClickSecondary = null,
  primaryDisabled = false,
}) => {
  const history = useHistory();

  const onClickCancel =
    onClickSecondary ??
    (() => {
      history.goBack();
    });
  return (
    <>
      <Spacer size={42} />
      <Buttons>
        <Button onClick={onClickCancel}>{loading ? "Close" : "Cancel"}</Button>
        <SecondaryButton
          disabled={loading || primaryDisabled}
          onClick={!loading && !primaryDisabled && onClickPrimary}
        >
          Continue
        </SecondaryButton>
      </Buttons>
      <Spacer size={24} />
    </>
  );
};

export default ModalButtons;
